// RightBar 发布提示点击跳转href
export const RIGHT_BAR_PUBLISH_HREF =
  'https://www.yuque.com/docs/share/962f09e2-e403-459b-b2b1-099306aed4d3?#'

// 布局常量
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}

// 相机旋转
export const cameraRotateList = [
  'Right-top',
  'Right-bottom',
  'Left-top',
  'Left-bottom'
]

// 案例详情限制图片上传上限
export const CASE_CONTENT_IMAGE_LIMIT = 50
